
import { FilmInventory } from "@/types/inventory";
import { EditFilmDialog } from "./EditFilmDialog";
import { TransferFilmDialog } from "./TransferFilmDialog";
import { DeleteFilmButton } from "./DeleteFilmButton";
import { Button } from "@/components/ui/button";
import { Edit, Camera, Trash2 } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { useTranslation } from "@/hooks/useTranslation";

interface FilmActionsProps {
  film: FilmInventory;
  showTransfer: boolean;
  onActionComplete: () => void;
}

export function FilmActions({ film, showTransfer, onActionComplete }: FilmActionsProps) {
  const { t } = useTranslation();
  
  return (
    <div className="flex items-center gap-2 justify-end">
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <EditFilmDialog 
              film={film} 
              onEditComplete={onActionComplete} 
              trigger={
                <Button variant="ghost" size="icon" className="h-8 w-8 text-blue-600 hover:bg-blue-50">
                  <Edit className="h-4 w-4" />
                </Button>
              }
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>{t('edit_film')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
      
      {showTransfer && (
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <TransferFilmDialog 
                film={film} 
                onComplete={onActionComplete} 
                trigger={
                  <Button variant="ghost" size="icon" className="h-8 w-8 text-orange-600 hover:bg-orange-50">
                    <Camera className="h-4 w-4" />
                  </Button>
                }
              />
            </TooltipTrigger>
            <TooltipContent>
              <p>{t('mark_exposed')}</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      )}
      
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <DeleteFilmButton 
              film={film} 
              onDeleteComplete={onActionComplete} 
              trigger={
                <Button variant="ghost" size="icon" className="h-8 w-8 text-red-600 hover:bg-red-50">
                  <Trash2 className="h-4 w-4" />
                </Button>
              }
            />
          </TooltipTrigger>
          <TooltipContent>
            <p>{t('delete_film')}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    </div>
  );
}
